import React from 'react';
import PropTypes from 'prop-types';

const GoogleMapsLink = ({ location }) => {
  const url = `https://www.google.com/maps/?q=${location.lat},${location.lng}`;
  return (
    <a href={url} target="_blank">
      {location.address} {location.postalCode}
    </a>
  );
};

GoogleMapsLink.propTypes = {
  location: PropTypes.shape({
    address: PropTypes.string.isRequired,
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }).isRequired,
};

export { GoogleMapsLink };
